<template>
	<Loading :loading="loading">
	<div class="container singleItem">
		<!-- No product returns product.product as empty array. Otherwise it's an object -->
		<div id="product" v-if="product && !Array.isArray(product)">
			<div class="row">
				<Breadcrumbs />
			</div>
			<!-- <div class="row">
				<div class="col-12">
				<router-link
					v-if="$route.query.subcategory && $route.query.category"
					:to="{name:'subcategory', 
					params:{category: $route.query.category, subcategory: $route.query.subcategory},
					query:{refine: $route.query.refine}
					}"
				>Back to Listing</router-link>

				<a
					v-if="!$route.query.subcategory"
					@click="$router.go(-1)"
					href="#"
				>Back to Search Results</a>
				<h1>{{product.title}} - {{product.product_code}}</h1>
				</div>
			</div> -->
			<div class="row">
				<div class="col-12 col-md-7 mb-3">
					<ProductImages :images="product.images" :productName="product.title" :stickerId="product.product_promotion_sticker_id_fk"/>
					</div>
					<div class="col-12 col-md-5 zoomContainer">
					<h1 class="productTitle">{{product.title}}</h1>
					<DebugProductPrices :product="product"  v-if="product.all_prices"/>
					<ProductPrices v-if="$store.state.auth.loggedIn === true" :product="product"/>
					<ProductPublicPrices v-else :product="product" />


					<ProductInStock 
						:core="product.core_stock_item"
						:available="product.stock_available"
					/>

					<div v-if="product.product_code" class="row">
						<div class="col-12 sku">
						SKU: {{product.product_code}}
						</div>
					</div>
					<div v-if="!product.price_expired">
						<ProductAddToCart v-if="$store.state.auth.loggedIn === true" :product="product" :source="source" />
					</div>
					<div v-else>
						<FavouritesButton class="mb-1" :itemId="product.id">Add to favourites</FavouritesButton>
						<!-- If product's price has expired then show the price request button -->
						<ProductGetPrice v-if="$store.state.auth.loggedIn === true" :product="product" />
					</div>
					
					<a v-if="product.product_url" class="btn btn-green d-block d-md-inline-block my-3 mx-auto" :href="product.product_url" target="_blank">More Information <ExternalLinkIcon fill="white" style="padding:2px"/> </a>
					<p v-if="$store.state.auth.loggedIn && product.freight_quote_required == true" class="red">Freight is TBA on this item, depending on delivery area and/or quantity required - to request a full quote, 
						including freight cost, use the 
						<router-link :to="{name:'get-a-price', query:{brand: product.brand, productCode: product.product_code}}">price request</router-link>
						form and our team will get back to you.
					</p>

					<div class="variants">
						<Variants
						v-if="Object.keys(variants).length > 0"
						:variants="variants"
						:product="product"
						/>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 mb-3">
				<ProductTabs :product="product" />
				</div>
			</div>
			<div v-if="recommended && recommended.length > 0" class="row recommendations">
				<h2 class="textRed specialFont">You may also like...</h2>
				<ProductCarousel :items="recommended"/>
			</div>
				<!-- Gives google more information about a product, not visible -->
				<!-- Set head content of product pages -->
				<ProductMicroData  :product="product" />
				<vue-headful
					v-if="product"
					:title="'Buy ' + product.title"
					:description="productDescription"
					:keywords="product.keywords"
				/>
			</div>
			<div v-else class="col-12 my-3 text-center">
				<!-- Can't find item -->
				<p>Oops we can't find that item.</p>
				<p>It might have been removed from our website.</p>
				<p>Please contact us if you would like to know more.</p>
			</div>
		</div>
	</Loading>
</template>

<script>
import { fetchProduct, fetchRecommendedProducts } from "@/network/productRequests.js";
import { mapGetters } from "vuex"

import ExternalLinkIcon from '@/assets/img/external-link.svg';

import Loading from "@/components/loading/Loading";

import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";

import Variants from "./ProductVariants";
import ProductPrices from "./ProductPrices";
import ProductPublicPrices from "./ProductPublicPrices";
import ProductImages from "./ProductImages";
import ProductTabs from "./ProductTabs";
import ProductMicroData from "./ProductMicroData";
import ProductAddToCart from "./ProductAddToCart";
import ProductGetPrice from "./ProductGetPrice";
import ProductInStock from "./ProductInStock";

import FavouritesButton from "@/components/buttons/FavouritesButton";

import ProductCarousel from "@/components/productCarousel/productCarousel";

import DebugProductPrices from "./DebugPrices"

import { makeProductObject } from "@/gaUtils";
export default {
	name: "Product",
	components: {
		Loading,
		ProductImages,
		ProductPrices,
		Variants,
		ProductMicroData,
		Breadcrumbs,
		ProductTabs,
		ProductPublicPrices,
		ProductAddToCart,
		ProductGetPrice,
		ProductCarousel,
		DebugProductPrices,
		ExternalLinkIcon,
		FavouritesButton,
		ProductInStock,
	},
	data: () => {
		return {
			productData: null,
			loading: true,
			recommended: [],
			source: null
		};
	},
	watch: {
		"$route.params"() {
			this.loadData(); //ensures that product is updated if URL changes
		}
	},
	created() {
		this.loadData();
		if(this.$route.params.source) {
			this.source = this.$route.params.source
		}
	},
	computed: {
		...mapGetters({
			// map categories to store.reference.categories
			categoriesMap: "reference/categoriesMap"
		}),
		product() {
			if (this.productData) {
				return this.productData.product;
			}
			return null;
		},
		variants() {
			if (this.productData) {
				return this.productData.variants;
			}
			return null;
		},
		recommendations() {
			return this.recommended
				.slice()
				.sort((a, b) => {
					return parseFloat(b.score) - parseFloat(a.score);
				})
				.filter(item => parseFloat(item.score) > 0.97);
		},
		productDescription() {
			return "Save up to $" + this.product.prices.savings_amounts.gold + " on " + this.product.title;
		},
		includeWellingtonShowroom() {
			// If The product is core stock (In the wellington showroom) and it's considered either not in stock elsewhere or instock and doesn't have wellington selected or stock array is supplied but it is empty
			return this.product.core_stock_item == 1 && (!this.product.stock_available || (this.product.stock_available && ((this.product.stock_available.length == 0) ||(this.product.stock_available.length > 0 && Object.values(this.product.stock_available).indexOf("Wellington Showroom") == -1))))
		},
		list() {
			let list = "";
			const cat = this.$router.currentRoute.query.category || null
			const subcat = this.$router.currentRoute.query.subcategory || null
			if (this.source) {
				if (this.source == "search") {
					list = "Search Results"
				}
				if (this.source == "window") {
					list = "Window Shop"
				}
				if (this.source == "specials") {
					list = "Specials"
				}
			} else {
				if(cat && subcat) {
					list = this.categoriesMap[cat].category + "/" + this.categoriesMap[subcat].category
				} else {
					list = "Offsite" 
				}
			}
			return list
		}
	},
	methods: {
		loadData() {
			this.productData = null;
			var query_data = {
				productId: this.$route.params.product
			};
			fetchProduct(
				query_data,
				product => {
					this.productData = product;
					this.loading = false;
					this.sendGA()
				},
				error => {
					console.log(error);
				}
			);

			//delay so product can load first
			setTimeout(() => {
				this.recommended = [];
				fetchRecommendedProducts(query_data, recommendations =>{
					this.recommended = recommendations;
				})
			}, 300);

		},
		sendGA() {
			this.$gtm.trackEvent({
				event: "productView",
				ecommerce: {
					detail: {
						actionField: {
							list: this.list
						},
						products: [makeProductObject(this.productData.product, null, this.list)]
					}
				}
			})
		}
	}
};
</script>

<style lang="scss" scoped>
.productTitle{
	font-size: 1.5em;
	font-weight:bold;
}

.prices {
	margin-bottom: 10px;
	.retail {
		font-size: 0.7em;
		color: grey;
	}
	.platinum {
		color: gold;
		font-size: 0.8em;
	}
}

.description::v-deep *{
	white-space: normal!important; //prevents no text wrapping
}

.sku{
	margin-top:10px;
	margin-bottom:10px;
}


.recommendations{
	margin-top:20px;
	margin-bottom:20px;
}

</style>
